export default "__VITE_ASSET__ffc6c832__"